import React from 'react';
import $ from 'jquery';
import ReactDOM from 'react-dom';
import URI from 'urijs';
import { appendScopeParameter } from '@bingads-webui-campaign/summary-grid-helper';
import {
  dismissCallout,
  ACCOUNTS_GRID_CALLOUT_MOUNTING_DOM,
  ACCOUNTS_GRID_POPOVER_CLASSNAME,
  getAutoPlacement,
} from '@bingads-webui-campaign-react/accounts-grid-factory';
import { PopoverWithLock, Utils } from '@bingads-webui-campaign-react/accounts-summary-common';
import { createElementBasedFluctuationPopupFactory } from '@bingads-webui-campaign-react/fluctuation-popup';
import { getRoutePathById, allSiteMap } from '@bingads-webui-campaign-react/with-site-map';
import { keyCode } from '@bingads-webui/keycode';

const MaxCalloutWidth = 325; // this value is defined in global style

export const getColumnActionEvents = ({
  serverContext,
  instrumentation,
  scope,
  getjsDataCampaign,
  appConfig,
  perfMarker,
}) =>
  // Fluctuation popup need some dependencies which we cannot get from upper level. So we add one more layer of function here.
  ({ accountSummaryi18n, azureUrlRewrite }) =>
    (view) => {
      const i18n = accountSummaryi18n;

      const showFluctuationInsightsPopup = (event) => {
        event.stopPropagation();
        const { currentTarget } = event;
        const key = view.gridView.keyOfElement(event.target);
        const account = view.gridView.itemWithKey(key);
        const dateRange = view.dateFilter.getCurrentDateRange();

        const dismissFluc = ({ isLastFluc }) => {
          if (isLastFluc) {
            Utils.forceAccountsGridRefresh({ gridView: view.gridView, getjsDataCampaign });
          }
        };

        createElementBasedFluctuationPopupFactory({
          triggerButton: currentTarget,
          deps: {
            i18n,
            context: {
              ...serverContext,
              scope,
              CurrentAccount: { Id: account.Id },
            },
            instrumentation,
            azure: azureUrlRewrite,
            appConfig,
          },
          metrics: [{
            name: currentTarget.getAttribute('data-metric-name'),
            value: currentTarget.getAttribute('data-metric-value'),
            type: currentTarget.getAttribute('data-metric-type'),
          }],
          isForVNext: true,
          canViewAllInsights: true,
          asyncLoadFluctuationConfig: {
            dateRange: {
              startDate: dateRange.start,
              endDate: dateRange.end,
            },
            fluctuationTypeIds: [currentTarget.getAttribute('data-metric-type')],
          },
          onFlucDismiss: dismissFluc,
          fromScenario: 'PerformanceGrid',
          onDismiss: () => {
            if (currentTarget) {
              currentTarget.focus();
            }
          },
          perfMarker,
        }, document.getElementById(ACCOUNTS_GRID_CALLOUT_MOUNTING_DOM));
      };

      const showFluctuationInsightsTooltip = (event) => {
        const fluctuationTooltipCalloutProp = {
          parentGrid: view,
          popoverId: 'fluctuation-tooltip-id',
          target: event.currentTarget,
          hasCloseButton: false,
          placement: 'top',
          onClose: dismissCallout,
          contentView: () => (<span className="fluctuation-tooltip">{i18n.getString('Fluctuation_Insights_Icon_Tooltip')}</span>),
        };

        ReactDOM.render(
          <PopoverWithLock {...fluctuationTooltipCalloutProp} />,
          document.getElementById(ACCOUNTS_GRID_CALLOUT_MOUNTING_DOM)
        );
      };

      const filterEnterKeyDown = eventHandler => (event, ...args) => {
        if (event.keyCode === keyCode.Enter) {
          eventHandler(event, ...args);
        }
      };

      // Tooltip when hovering over spend text, to show budget center entry
      const showBudgetCenterHelpTooltip = (event) => {
        const url = getRoutePathById(allSiteMap, 'budget-center');
        const uri = new URI(url);
        appendScopeParameter(uri, scope);
        const key = view.gridView.keyOfElement(event.target);
        const account = view.gridView.itemWithKey(key);
        uri.addQuery('aid', account.Id);
        uri.addQuery('entrypoint', 'performancegrid');
        const actionLink = uri.toString();

        const placement = getAutoPlacement(event.target, MaxCalloutWidth);

        const budgetCenterHelpTooltipCalloutProp = {
          parentGrid: view.gridView,
          popoverId: 'budget-center-help-tooltip-id',
          target: event.currentTarget,
          hasCloseButton: false,
          placement,
          onClose: dismissCallout,
          focusLockContent: true,
          contentView: () => (
            <>
              <div className="budget-center-help-tooltip">{i18n.getString('AccountGrid_BudgetCenter_HelpText')}</div>
              <a className="budget-center-view-link" href={actionLink}>{i18n.getString('Campaign_BudgetCenter_ViewLink')}</a>
            </>
          ),
        };

        ReactDOM.render(
          <PopoverWithLock {...budgetCenterHelpTooltipCalloutProp} />,
          document.getElementById(ACCOUNTS_GRID_CALLOUT_MOUNTING_DOM)
        );
      };

      return {
        'click .performance-metrics-fluctuation .clickable': showFluctuationInsightsPopup,
        'mouseenter .performance-metrics-fluctuation .clickable': showFluctuationInsightsTooltip,
        'mouseleave .performance-metrics-fluctuation .clickable': (event) => {
          if ($(event.relatedTarget).closest(`.${ACCOUNTS_GRID_POPOVER_CLASSNAME}`).length === 0) {
            view.trigger('closePopup');
          }
        },
        'click .performance-metrics-value .budget-center-entry': showBudgetCenterHelpTooltip,
        'mouseenter .performance-metrics-value .budget-center-entry': showBudgetCenterHelpTooltip,
        'mouseleave .performance-metrics-value .budget-center-entry': (event) => {
          if ($(event.relatedTarget).closest(`.${ACCOUNTS_GRID_POPOVER_CLASSNAME}`).length === 0) {
            view.trigger('closePopup');
          }
        },
        'keydown .performance-metrics-value .budget-center-entry': filterEnterKeyDown(e => showBudgetCenterHelpTooltip(e)),
      };
    };
